import { useQuery } from "@apollo/client";

import { GqlClient, GqlClientUserGetAllUsersParams, gql } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

export const CLIENT_USER_GET_ALL_WITH_ACCESS_TO_CLIENT = gql(`
    query ClientUserGetAllWithAccessToClient($clientId: ID!, $params: GqlClientUserGetAllUsersParams!) {
        clientUserGetAllWithAccessToClient(clientId: $clientId, params: $params) {
        queryInfo {
            filterOptions {
                ... on GqlFilterOptionText {
                    filterType
                    label
                    key
                }
                ... on GqlFilterOptionSelect {
                    filterType
                    label
                    key
                    options {
                        label
                        value
                    }
                }
                ... on GqlFilterOptionMultiSelect {
                    filterType
                    label
                    key
                    dataModel
                }
                ... on GqlFilterOptionBoolean {
                    filterType
                    label
                    key
                }
            }
            sortableColumns
            paginationOption {
            page
            total
            }
        }
        data {
            id
            clientId
            roleId
            userId
            user {
            firstName
            lastName
            email
            phone
            profilePictureMedia {
                url
            }
            }
            clientRole {
            name
            }
        }
        }
    }
`);

export default function useClientUserGetAllWithAccessToClient(
    params: GqlClientUserGetAllUsersParams,
    client: GqlClient,
) {
    const { data, loading, error } = useQuery(CLIENT_USER_GET_ALL_WITH_ACCESS_TO_CLIENT, {
        variables: {
            params: params,
            clientId: client?.id,
        },
        errorPolicy: "all",
    });

    const queryInfo = data?.clientUserGetAllWithAccessToClient?.queryInfo;
    const [filterOptions, total] = useCacheFilterOptions(queryInfo?.filterOptions, queryInfo?.paginationOption.total);
    return {
        loading,
        error,
        totalRows: total,
        sortableColumns: queryInfo?.sortableColumns,
        filterOptions: filterOptions,
        data: data?.clientUserGetAllWithAccessToClient?.data,
    };
}
